var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconArtist = function SvgIconArtist(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User / User_Voice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 15.8334C12.5 13.9924 10.2614 12.5 7.5 12.5C4.73858 12.5 2.5 13.9924 2.5 15.8334M7.5 10C5.65905 10 4.16667 8.50766 4.16667 6.66671C4.16667 4.82576 5.65905 3.33337 7.5 3.33337C9.34095 3.33337 10.8333 4.82576 10.8333 6.66671C10.8333 8.50766 9.34095 10 7.5 10Z",
    stroke: "#3C3C3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6701 5.00004H18.3368C18.7951 5.00004 19.1701 4.62504 19.1701 4.16671C19.1701 3.70837 18.7951 3.33337 18.3368 3.33337H16.6701C16.2118 3.33337 15.8368 3.70837 15.8368 4.16671V7.92504C15.4534 7.63337 14.9784 7.46671 14.4534 7.50004C13.5201 7.55837 12.7034 8.26671 12.5368 9.18337C12.4749 9.50866 12.4913 9.844 12.5846 10.1617C12.6779 10.4794 12.8455 10.7703 13.0734 11.0105C13.3014 11.2507 13.5832 11.4332 13.8956 11.5429C14.208 11.6527 14.542 11.6865 14.8701 11.6417C15.9201 11.5084 16.6701 10.5334 16.6701 9.47504V5.00004Z",
    fill: "#3C3C3B"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconArtist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-artist.123bf8bc88d26a85253f876a35d2234f.blank.svg";